import { computed, Ref, ref } from 'vue';

const useDepthChart = (orderbookIsLoading: Ref<boolean | null>) => {
  const rendererReady = ref(false);

  const onRendererReady = (isReady: boolean) => {
    rendererReady.value = isReady;
  };

  const showLoading = computed(() => orderbookIsLoading.value || !rendererReady.value);

  return {
    showLoading,
    onRendererReady,
  };
};

export default useDepthChart;
